<template>
  <container :class="['page-wrapper']">
    <flex :spacing="3">
      <flex-col :span="24">
        <test-toolbar>
          <checkbox label-size="xs" v-model="indeterminate" :label="$lang.indeterminate"  :icon-color="$root.$colors.primary" :icon-color-lightness="$root.$colors.bgColorLightness" /><!--
          --><checkbox label-size="xs" v-model="reversed" :label="$lang.reversed"  :icon-color="$root.$colors.primary" :icon-color-lightness="$root.$colors.bgColorLightness" /><!--
          --><checkbox label-size="xs" v-model="rounded" :label="$lang.rounded"  :icon-color="$root.$colors.primary" :icon-color-lightness="$root.$colors.bgColorLightness" /><!--
          --><checkbox label-size="xs" v-model="iconLeft" :label="$lang.iconLeft"  :icon-color="$root.$colors.primary" :icon-color-lightness="$root.$colors.bgColorLightness" /><!--
          --><checkbox label-size="xs" v-model="iconRight" :label="$lang.iconRight"  :icon-color="$root.$colors.primary" :icon-color-lightness="$root.$colors.bgColorLightness" /><!--
          --><btn :title="$lang.decrease" :disabled="indeterminate || this.value === 0" @click="setValue(true)" :class="['mx-1']" size="xs" icon="minus-circle" :bg-color="$root.colors.primary" :bg-color-lightness="$root.colors.bgColorLightness" color="white" /><!--
          --><btn :title="$lang.increase" :disabled="indeterminate || this.value === 100" @click="setValue()" :class="['mx-1']" size="xs" icon="plus-circle" :bg-color="$root.colors.primary" :bg-color-lightness="$root.colors.bgColorLightness" color="white" />
        </test-toolbar>
      </flex-col>
      <flex-col :span="24">
        <card>
          <card-text>
            <progressbar
              @click="log('click', 'progressbar', $event)"
              @progress="log('progress', 'progressbar', $event)"
              :height="height"
              :indeterminate="indeterminate"
              :progress-bg-color="$root.colors.primary"
              :progress-bg-color-lightness="$root.colors.bgColorLightness"
              :track-bg-color="$dark ? 'black' : 'gray'"
              :track-bg-color-lightness="$dark ? null : 300"
              :icon-color="$root.colors.primary"
              :icon-color-lightness="$root.colors.bgColorLightness"
              :value="value"
              :reversed="reversed"
              :rounded="rounded"
              :disabled="disabled"
              :comparator="100"
              :icon-right="iconRight ? 'check-circle' : null"
              :icon-left="iconLeft ? 'gas-station' : null" />
          </card-text>
        </card>
      </flex-col>
    </flex>
  </container>
</template>
<script>
import methods from '../../mixins/methods'

export default {
  name: 'PageProgressbar',
  mixins: [
    methods
  ],
  data () {
    return {
      step: 10,
      value: 50,
      height: '18px',
      disabled: false,
      iconRight: false,
      iconLeft: true,
      rounded: true,
      reversed: false,
      indeterminate: false
    }
  },
  methods: {
    setValue (negative = false) {
      const step = this.step
      const value = this.value
      this.value = negative ? value - step : value + step
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/ui/progressbar.vue